export const GA_EVENT = {
  GE_TRANSACTION_SUCCESS: 'GE_TRANSACTION_SUCCESS',
  GE_LOGIN_SUCCESS: 'GE_LOGIN_SUCCESS',
  GE_LOGIN_ERROR: 'GE_LOGIN_ERROR',
  GE_VIRTUAL_PV_EVENT: 'GE_VIRTUAL_PV_EVENT',
  GE_SIGNUP_SUCCESS: 'GE_SIGNUP_SUCCESS',
  GEWEB_SIGNUP_BACK: 'GEWEB_SIGNUP_BACK',
  GEWEB_SIGNUP_PIC: 'GEWEB_SIGNUP_PIC',
  DOWNLOAD_NEW_EXCEL_TEMPLATE: 'DOWNLOAD_NEW_EXCEL_TEMPLATE',
};

export const GA_CATEGORY = {
  CLICK: 'Click',
  TRANSACTION: 'Transaction',
  PAGE_VIEW: 'Pageview',
  GRAB_CONVERSION: 'Grab-Conversion',
  GRAB_ENGAGEMENT: 'Grab-Engagement',
};

export const GA_ACTION = {
  CREATE_SINGLE_BOOKING_SUCCESS: 'Create a single booking success',
  CREATE_BULK_BOOKING_SUCCESS: 'Create bulk booking success',
  LOGIN_SUCCESS: 'Login success',
  LOGIN: 'Login',
  CLICK: 'Click',
  CONFIRMED: 'Confirmed',
};

export const GA_PAGE_MAP = {
  BOOKING: 'GE_BOOKING',
  BOOKING_SUCCESS: 'GE_TRANSACTION_SUCCESS',
  REVIEW: 'GE_REVIEW_BOOKING',
  ONGOING: 'GE_ACTIVITY',
  LOGIN: 'GE_LOGIN',
  SIGNUP: 'GE_SIGNUP',
  ADMIN: 'GE_ADMINISTRATION',
  HELP: 'GE_HELP',
};

export const BOOKING_TRANSACTION = {
  SINGLE: 'Single Transaction',
  BULK: 'Bulk Transactions',
  SINGLE_BOOKING: 'SINGLE_BOOKING',
  MULTIPLE_BOOKING: 'MULTIPLE_BOOKING',
};

export const GA_STATUS = {
  SUCCESS: 'Success',
};

export const GA_LABELS = {
  ADD_DELIVERIES_DETAIL: 'Add Delivery Details',
  ADD_DELIVERY: 'Add Delivery',
  ON_GOING_BOOKINGS: 'Ongoing Bookings',
  RIDER_ASSIGNED: 'Rider Assigned',
};
